module.exports = __webpack_public_path__ + "img/Icon-Search-black.f1458c7b.svg";